module.exports = __webpack_public_path__ + "assets/img/logAudit-module3-1.3a2ae4f6.jpg";